import { createSlice } from '@reduxjs/toolkit'

export const platformSlice = createSlice({
  name: 'platform',
  initialState: {
    platform: null,
    statusBarHeight: 0,
    bottomInset: 0,
    connection: false,
  },

  reducers: {
    updatePlatform: (state, action) => {
      state.platform = action.payload?.platform;
      state.statusBarHeight = action.payload?.statusBarHeight;
      state.bottomInset = action.payload?.bottomInset ?? 0;
      },
    updateConnection: (state, action) => {
      state.connection = action.payload?.connection
    }
    },
});

// Action creators are generated for each case reducer function
export const { updatePlatform , updateConnection} = platformSlice.actions;

export default platformSlice.reducer
